<template>
  <aside>
    <div class="float-buttons">
      <a class="go-to entry cart" id="PurchaseOrder" @click="goCart" href="javascript:;">
        <i class="fa fa-goukedan"></i>
        <span class="badge cart-count" :class="{'not-empty': shoppingSum }">{{ shoppingSum }}</span>
        <div class="entey-tips" style="text-overflow:ellipsis;word-break:keep-all;"><span>购课单</span></div>
      </a>
      <el-popover popper-class="custom-popover" placement="left" :trigger="isMobile ? 'click': 'hover'">
        <div id="tooltips">
          <div class="inner">
            <p class="row1">客服电话</p>
            <p class="row2">010-80455397<br/>010-89631145</p>
          </div>
          <div class="inner">
            <p class="row1">工作时间</p>
            <p class="row2">10:00-19:00</p>
          </div>
          <div class="vertical-line"></div>
        </div>
        <a class="go-to entry" id="tel" slot="reference" href="tel:010-80455397">
          <div class="divider"></div>
          <i class="fa fa-phone"></i>
          <div class="entey-tips" style="text-overflow:ellipsis;word-break:keep-all;"><span>客服电话</span></div>
        </a>
      </el-popover>
      <a class="go-to entry go-top" @click="backTop" href="javascript:;" title="返回顶部">
        <div class="divider"></div>
        <i class="fa fa-back"></i>
        <div class="entey-tips" style="text-overflow:ellipsis;word-break:keep-all;">返回顶部</div>
      </a>
    </div>
    <a @click="visibleButtons" class="go-to entry btn-more" href="javascript:;">
      <i class="fa fa-more"></i>
    </a>
  </aside>
</template>

<script>
import $ from 'jquery'
import utils from '@/utils/utils'
import { mapState } from 'vuex'

export default {
  name: 'Aside',
  mounted () {
    this.handleScroll()
  },
  methods: {
    goCart () {
      if (this.$route.name === 'Cart') {
        $('#confirm-order-page').remove()
        $('#cart-view .cart-view-wrap').show()
      } else {
        this.$router.push({ path: '/cart' })
      }
    },
    backTop () {
      $('html,body').animate({ scrollTop: 0 }, 100)
    },
    handleScroll () {
      $('.go-top').hide()
      $(window).on('scroll', () => {
        var _stop = $(window).scrollTop()
        if (_stop >= 100 && this.isMobile === false) {
          $('.go-top').fadeIn()
        } else {
          $('.go-top').fadeOut()
        }
      })
    },
    visibleButtons () {
      this.$buttons = $('.float-buttons')
      if (this.$buttons.attr('data-slide') === 'visible') {
        this.$buttons.attr('data-slide', 'hidden')
        this.$buttons.find('.entry').not('.cart').not('.go-top').slideUp()
      } else {
        this.$buttons.attr('data-slide', 'visible')
        this.$buttons.find('.entry').not('.cart').not('.go-top').slideDown()
      }
    }
  },
  computed: {
    isMobile () {
      return utils.isMobile()
    },
    ...mapState({
      shoppingSum: state => state.shopping.shoppingSum
    }),
    shoppingState () {
      return this.shoppingSum > 0
    }
  },
  beforeDestroy () {
    $(window).off('scroll')
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/base";

  aside {
    position: fixed;
    right: 0;
    z-index: 100;
    top: 100%;
    transform: translateY(-345px);
    text-align: center;
    @media (max-width: 768px) {
      right: 0;
      top: unset;
      transform: none;
      bottom: 17%;
    }
    @media (min-width: 1440px) {
      right: calc((100% - 1140px) / 2 - 140px);
    }

    > .float-buttons {
      background-color: #fff;
      overflow: hidden;
      transition-property: height;
      transition-duration: 0.4s;
      transition-timing-function: ease-in;
      border-radius: 4px;
      box-shadow: 0 2px 13px 0 rgba(139, 152, 169, 0.07);
      @media (max-width: 768px) {
        box-shadow: 0 2px 19px 0 rgba(139, 152, 169, 0.22);
        a:not(.cart) {
          display: none;
        }
        .entey-tips {
          display: none;
        }
      }

      .divider {
        height: 1px;
        background: rgba(51, 51, 51, 0.06);
        border-radius: 2px;
        position: absolute;
        top: 0;
        left: 4px;
        right: 4px;
      }

      .badge {
        display: inline-block;
        min-width: 10px;
        padding: 3px 7px;
        font-size: 12px;
        font-weight: bold;
        color: #fff;
        line-height: 1;
        vertical-align: middle;
        white-space: nowrap;
        text-align: center;
        background-color: #c8c9cc;
        border-radius: 10px;
      }

      .nopay-carcolor {
        background-color: #c8c9cc;
      }

      .pay-carcolor {
        background: linear-gradient(90deg, #f85a4a 0%, #ff7668 100%);
      }

      .cart-count {
        position: absolute;
        border-radius: 50%;
        right: 14%;
        top: 10%;
        font-size: 12px;
        width: 20px;
        height: 20px;
        line-height: 20px;
        padding: 0;

        &.not-empty {
          background: linear-gradient(90deg, rgba(248, 90, 74, 1) 0%, rgba(255, 118, 104, 1) 100%);
        }
      }

      .cart-count.animated {
        animation: pluscart .3333s linear;
      }
    }

    a {
      position: relative;
      display: block;
      padding: 12px;
      text-align: center;
      color: #333;

      &:active,
      &:active:hover,
      &:focus:hover,
      &:hover,
      &:focus {
        color: $brand-success;
        text-decoration: none;

        .fa,
        .entey-tips {
          color: $brand-success;
        }
      }

      .fa {
        margin-bottom: 4px;
        font-size: 26px;
        color: #AEAEAE;
      }

      @media (max-width: 767px) {
        padding: 0;
        line-height: 46px;
        width: 48px;
        .fa {
          margin-bottom: 0;
          font-size: 24px;
        }
      }

      .entey-tips {
        color: #333333;
        font-size: 12px;
      }
    }

    .btn-more {
      width: 48px;
      height: 48px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 2px 19px 0 rgba(139, 152, 169, 0.22);
      border-radius: 4px;
      margin-top: 4px;
      padding: 0;
      display: none;
      line-height: 46px;
      @media (max-width: 768px) {
        display: block;
        .badge {
          display: inline-block;
          min-width: 10px;
          padding: 3px 7px;
          font-size: 12px;
          font-weight: bold;
          color: #fff;
          line-height: 1;
          vertical-align: middle;
          white-space: nowrap;
          text-align: center;
          border-radius: 10px;
        }
        .nopay-carcolor {
          background-color: #c8c9cc;
        }
        .pay-carcolor {
          background: linear-gradient(90deg, #f85a4a 0%, #ff7668 100%);
        }
        .cart-count {
          position: absolute;
          border-radius: 50%;
          right: 14%;
          top: 10%;
          font-size: 12px;
          width: 20px;
          height: 20px;
          line-height: 20px;
          padding: 0;

          &.not-empty {
            background: linear-gradient(90deg, rgba(248, 90, 74, 1) 0%, rgba(255, 118, 104, 1) 100%);
          }
        }

        .cart-count.animated {
          animation: pluscart .3333s linear;
        }
      }
    }
  }
</style>
<style lang="scss">
  .custom-popover {
    color: #333333;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 3px 27px 0 rgba(218, 218, 218, 0.5);
    max-width: 440px;

    #tooltips {
      min-width: 250px;

      .inner {
        display: inline-block;
        padding: 10px 0;
        width: 49%;
        text-align: center;
        vertical-align: top;

        .row1 {
          letter-spacing: 6.6px;
        }

        p:first-child {
          margin-bottom: 10px;
        }
      }

      .vertical-line {
        position: absolute;
        background-color: #bababa;;
        width: 1px;
        height: 50%;
        right: 50%;
        top: 20%;
        max-height: 50px;
      }
    }
  }
</style>
